import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import {
  EmbeddedReportService,
  FilterSet,
} from '../../components/embedded-report/embedded-report.service';
import EmbeddableReport from '../../interfaces/embeddable-report';
import Project from '../../interfaces/project';
import MetroStatArea from '../../interfaces/metro-stat-area';

@Component({
    selector: 'committee-reports',
    templateUrl: './committee-reports.component.html',
    styleUrls: ['./committee-reports.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CommitteeReportsComponent {
  @Input() projectId: string;
  @Input() project: Project;
  public reports: EmbeddableReport[] = [];
  public filterSet: FilterSet;
  constructor(public embeddedReporsService: EmbeddedReportService) {}
  ngOnInit() {
    this.filterSet = { project_id: this.projectId, msa: this._getMSA() };
    this.embeddedReporsService.getReports();
    this.embeddedReporsService.reports$.subscribe((reports) => {
      this.reports = reports.filter((report) => report.committee_dashboard);
    });
  }
  private _getMSA() {
    let msa: string | null = null;
    if (this.project?.properties) {
      let property = this.project.properties[0];
      if (property?.entity?.entityAddresses) {
        let entityAddress = property.entity.entityAddresses[0];
        if (entityAddress?.address?.zipCode?.county?.metroStatAreaCounties) {
          msa =
            entityAddress.address.zipCode.county.metroStatAreaCounties[0]
              ?.metroStatArea?.name ?? null;
        }
      }
    }

    return msa ?? '';
  }
  public openReport(event: Event, report: EmbeddableReport) {
    this.embeddedReporsService.selectReport(report.name);
    this.embeddedReporsService.setFilters(this.filterSet);
    if (report.full_url) {
      this.embeddedReporsService.popupReport(event, report);
    } else {
      this.embeddedReporsService.setShow(true);
    }
  }
}
